//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ColumnsSelect from '@/components/ColumnsSelect'
import SearchInput from '@/components/SearchInput'
import CommentsDialog from './components/CommentsDialog'
import Sadasi from '@/api/promotores/sadasi.api'
import SadasiProspectSaveDialog from './components/SadasiProspectSaveDialog'

export default {
	components: { SearchInput, ColumnsSelect },
	data() {
		return {
			columns: [
				{ name: 'nombre_completo', label: 'Nombre Completo', field: 'nombre_completo', align: 'left'  },
				{ name: 'email', label: 'Correo electrónico', field: 'email', align: 'left'  },
				{ name: 'celular', label: 'Celular', field: 'celular', align: 'left' },
				{ name: 'tipo_credito', label: 'Tipo de Credito', field: 'tipo_credito', align: 'left' },
				{ name: 'promotor', label: 'Promotor', field: 'usuario', align: 'left', sortable: true  },
				{ name: 'status', label: 'Estado', field: 'status', align: 'left', sortable: true  },
				{ name: 'mensaje', label: 'Mensaje de seguimiento', field: 'followups', align: 'left', sortable: true  },
				{ name: 'comentarios', label: 'Comentarios', field: 'comentarios' },
				{ name: 'created_at', label: 'Creado', field: 'created_at', align: 'left', sortable: true  },
				{ name: 'updated_at', label: 'Actualizado', field: 'updated_at', align: 'left', sortable: true  },
			],
			visible_columns: [
				'nombre_completo',
				'email',
				'celular',
				'promotor',
				'status',
				'comentarios',
				'created_at',
				'updated_at',
				'mensaje',
			],
			filter: null,
			data: [],
			loading: false,
		}
	},

	mounted() {
		this.getProspects()
	},

	methods: {
		async getProspects() {
			try {
				this.loading = true
				this.data = await Sadasi.prospects()
			} finally {
				this.loading = false;
			}
		},

		createProspect() {
			this.$q.dialog({
				component: SadasiProspectSaveDialog
			})

				.onOk((prospecto) => {
					this.getProspects()
				})
		},

		async openComentariosDialog({ _id, nombre_completo, email, comentarios}) {
			this.$q.dialog({
				component: CommentsDialog,
				prospecto_id: _id,
				title: `Comentarios para ${nombre_completo}`,
				comentarios,
				organizacion_id: 'sadasi',
			})
				.onOk((comentario) => {
					comentarios.push(comentario);
				})
		},
	}

}
